export default {
  carrierFees: []
}
